<div class="main-container">
    <div class="drop-down-container" [ngClass]="{disabled: disabled}">
        <div class="header">
            <div class="head-title" [ngClass]="{focus: showDropDownOptions}" [ngClass]="isButton ? styleObject : {}">
                <div class="selected-item">
                    <img class="icons" *ngIf="icon" src="assets/24x24/{{ icon }}.svg" alt="{{ icon }}" />
                    <span class="title" [ngStyle]="{ 'color': isButton ? 'white': '' }">{{ title }}
                        <span *ngIf="isButton">+</span>
                    </span>
                </div>
                <img class="icons" src="assets/12x12/sort-asc.svg" alt="expand" *ngIf="!isButton" />
            </div>
        </div>
        <div class="options" *ngIf="showDropDownOptions">
            <input #searchInput type="search" placeholder='Search Workspace' (click)="$event.stopPropagation()"
                (focus)="$event.stopPropagation()">
            <div class="option" *ngFor="let option of filteredOptions; let i = index"
                [ngClass]="{ active: option === title }">
                <div class="option-item" (click)="getOption(option[titleName], i, option[valueName], option)"
                    [ngClass]="{ active: option === title }">
                    <div class="option-name" *ngIf="titleName.length > 0" value="option[valueName]">
                        {{ option[titleName] }}
                    </div>
                    <ng-container *ngIf="titleName.length === 0">
                        <div class="option-name" value="option[valueName]" *ngIf="option !== title; else otherOptions">
                            {{ option }}
                        </div>
                        <ng-template #otherOptions>
                            <div class="option-name">{{ title | titlecase }}</div>
                            <img src="assets/12x12/check.svg" alt="" srcset="" />
                        </ng-template>
                    </ng-container>
                    <div class="option-asset-code" *ngIf="hasCaption">
                        {{ option[captionItem] }}
                    </div>
                </div>
            </div>
        </div>
    </div>